import React, { Component } from 'react';
import * as Utils from '../utils';
import * as Constants from '../constants'
import Actions from '../actions/api';
import { v4 as uuidv4 } from 'uuid';

import './Home.scss';
import { ValidationForm, TextInput, } from "react-bootstrap4-form-validation";
import validator from "validator";

// import { LinkContainer } from 'react-router-bootstrap';
import iconEngage from '../img/icon-engage.png';
import iconInteract from '../img/icon-interact.png';
import iconInform from '../img/icon-inform.png';
import iconInspire from '../img/icon-inspire.png';
import iconConnect from '../img/icon-connect.png';
import iconEnhance from '../img/icon-enhance.png';
// import FloatingLabel from "react-bootstrap-floating-label";

export default class Home extends Component {
  constructor(props) {
    super(props)

    this.digitalSignageForm = React.createRef();
    this.onHoldMarketingForm = React.createRef();
    this.onPremiseMessagingForm = React.createRef();
    this.wifiMarketingForm = React.createRef();
    this.scentMarketingForm = React.createRef();

    this.validationForm = React.createRef()
    this.selectYourProductHeader = React.createRef();

    this.localCache = Utils.getLocalCache();

    let userDetails = this.localCache.userDetails || {
      firstName: '',
      lastName: '',
      organization: '',
      email: '',
      phone: '',
      ext: '',
    }

    this.state = {
      selectedProducts: this.localCache.selectedProducts || [],
      userDetails: userDetails,
      showSelectProductErrorMessage: false,
      processingSubmit: false,

    }
  }

  storeLocalCache = () => {
    Utils.storeLocalCache(this.localCache);
  }

  handleUserInfoChanged = (e) => {
    let value = e.target.value;
    const property = e.target.name;

    if(property == 'phone')
      value = value.replace(/[^0-9]/g, '');

    let userDetails = this.state.userDetails;
    userDetails[property] = value;

    this.setState({userDetails : userDetails})

    this.localCache.userDetails = userDetails;
    this.storeLocalCache();
  }

  handleProductCheckboxClicked = (productToggle) => (e) => {
    e.preventDefault();

    let selectedProducts = this.state.selectedProducts;
    if(selectedProducts.includes(productToggle)){
      selectedProducts = selectedProducts.filter(item => item !== productToggle);
    }else{
      selectedProducts.push(productToggle);
    }
    this.setState({
      selectedProducts: selectedProducts,
      showSelectProductErrorMessage: false,
    });

    //for now force them to click next in step two after toggling a product until I think of a better way
    this.localCache.stepTwoCompleted = false;
    this.localCache.selectedProducts = selectedProducts;
    this.storeLocalCache();

  }

  handleNextClicked = (e) => {
    e.preventDefault();

    this.validationForm.current.resetValidationState();
    this.validationForm.current.handleSubmit(e);

  }

  handleErrorSubmit = (e, formData, errorInputs) => {
    //hacky way to reset the for, is-valid state that seemed to get messed up by calling
    //handleSubmit directly
    const inputs = this.validationForm.current.inputs;
    for( const key in inputs) {
      inputs[key].clearError();
      inputs[key].checkError();
    }
  }

  handleOnSubmit = (e, formData, inputs) => {

    this.validationForm.current.resetValidationState();

    //check that a product was selected
    if(this.state.selectedProducts.length == 0){
      this.setState({showSelectProductErrorMessage: true})

      Utils.scrollToElement(this.selectYourProductHeader.current);
      return;
    }

    //store step one data
    if(this.localCache.uuid == null){
      this.localCache.uuid = uuidv4();
      this.storeLocalCache();
    }

    const data = {
      'data': {
        'user_details': this.localCache.userDetails,
        'selected_products': this.localCache.selectedProducts,
      },
      'query_params': Utils.getUtmCampaignValues(),
      'uuid': this.localCache.uuid,
    }


    Actions.post('/step-one/', data).then( response => {
      this.stepOneSaveComplete();
    }).catch(error => {
      this.stepOneSaveComplete();
    });


    this.setState({processingSubmit : true})
  }

  stepOneSaveComplete = () => {
    let nextLocation;

    if(Constants.PURCHASEABLE_PRODUCTS.some(x => this.localCache.selectedProducts.includes(x)))
      nextLocation = 'step-2';
    else
      nextLocation = 'thank-you';


    setTimeout(function(){
      window.location.assign(nextLocation)
    }, 0);
  }

  render () {
      return (
        <div className="checkout-bg">
          <div className="bg-layer">
            <svg width="1960" height="384" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity=".66" clipPath="url(#clip0)"><path d="M731.693 124.469L211.857 83.505l121.63-295.696 398.206 336.66z" fill="#fff" fillOpacity=".8"></path><path d="M348.211-178.554L744.708 156.66l-517.604-40.788 121.107-294.426z" stroke="#000" strokeOpacity=".09"></path><path d="M1576.57 165.481l114.32 111.979-120.78 47.916 6.46-159.895z" fill="#fff" fillOpacity=".8"></path><path d="M1577.01 313.811l6.39-158.002 112.96 110.654-119.35 47.348z" stroke="#000" strokeOpacity=".09"></path><path d="M1593.13 53.39l66.74-91.534 46.54 91.123-113.28.41z" fill="#fff" fillOpacity=".8"></path><path d="M1703.81 47.645l-111.48.404 65.68-90.078 45.8 89.674z" stroke="#000" strokeOpacity=".09"></path><path d="M301.006 55.773l162.407 170.939-189.145 63.329 26.738-234.268z" fill="#000" fillOpacity=".05"></path><path d="M284.396 293.634l26.527-232.425 161.129 169.595-187.656 62.83z" stroke="#000" strokeOpacity=".09"></path><path d="M188.059-57.03l-37.985 272.301L.833 144.308 188.059-57.029z" fill="#000" fillOpacity=".05"></path><path d="M3.654 154.775L189.335-44.902l-37.671 270.054-148.01-70.377z" stroke="#000" strokeOpacity=".09"></path><path d="M755.635-114.374l125.992 152.66-163.912 41.612 37.92-194.272z" fill="#000" fillOpacity=".05"></path><path d="M726.134 83.4l37.565-192.459L888.516 42.177 726.134 83.4z" stroke="#000" strokeOpacity=".09"></path><g><path d="M1094.77 125.6l143.26-206.32 98.68 138.828-241.94 67.492z" fill="#000" fillOpacity=".05"></path><path d="M1338.51 47.91L1098.6 114.84l142.05-204.596 97.86 137.668z" stroke="#000" strokeOpacity=".09"></path></g><g><path d="M1688.26 206.322l110.93-237.473L1949 179.601l-260.74 26.721z" fill="#000" fillOpacity=".05"></path><path d="M1948.52 166.676l-259.01 26.544L1799.7-42.677l148.82 209.353z" stroke="#000" strokeOpacity=".09"></path></g><g><path d="M1492.85 102.601l126.73 6.405-46.51 91.909-80.22-98.314z" fill="#000" fillOpacity=".05"></path><path d="M1578.21 198.211l-79.02-96.846 124.83 6.309-45.81 90.537z" stroke="#000" strokeOpacity=".09"></path></g><g><path d="M322.687 214.438l-10.488 70.361-54.423-41.252 64.911-29.109z" fill="#fff" fillOpacity=".8"></path><path d="M264.887 244.184l63.307-28.391-10.229 68.624-53.078-40.233z" stroke="#000" strokeOpacity=".09"></path></g><g><path d="M991.744-188.543l57.556 278-227.879-50.874 170.323-227.126z" fill="#fff" fillOpacity=".8"></path><path d="M842.635 28.836l169.195-225.621L1069 79.372 842.635 28.836z" stroke="#000" strokeOpacity=".09"></path><path d="M1639.33-155.823l-301.35 264.459-96.39-213.958 397.74-50.501z" fill="#fff" fillOpacity=".8"></path><path d="M1268.05-96.524l395.45-50.211-299.61 262.936-95.84-212.725z" stroke="#000" strokeOpacity=".09"></path></g></g><defs><clipPath id="clip0"><path fill="#fff" d="M0 0h1960v384H0z"></path></clipPath></defs></svg>
          </div>
          <div className="bs-form">
            <div className="container">
              <div className="row">
                <div className="col-12 col-xl-8">
                  <h3 className="mt-4">Sign Up for Spectrio</h3>
                  <p className="muted">
                    Take the next step towards increasing your customer engagement today!
                  </p>

                  <ValidationForm ref={this.validationForm} onSubmit={this.handleOnSubmit} onErrorSubmit={this.handleErrorSubmit}>
                    <div className="form-row margin-top-main">
                      <div className="col-12 col-lg-6">
                        <div className="form-group">
                          <TextInput
                            name="firstName"
                            id="firstName"
                            placeholder="First Name"
                            value={this.state.userDetails.firstName}
                            onChange={this.handleUserInfoChanged}
                            autoComplete="given-name"
                            required
                          />
                          <label htmlFor="firstName">First Name</label>
                        </div>
                      </div>
                      <div className="col-12 col-lg-6">
                        <div className="form-group">
                          <TextInput
                            name="lastName"
                            id="lastName"
                            placeholder="Last Name"
                            value={this.state.userDetails.lastName}
                            onChange={this.handleUserInfoChanged}
                            autoComplete="family-name"
                            required
                          />
                          <label htmlFor="lastName">Last Name</label>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <TextInput
                        name="organization"
                        id="organization"
                        placeholder="Company Name"
                        value={this.state.userDetails.organization}
                        onChange={this.handleUserInfoChanged}
                        autoComplete="organization"
                        required
                      />
                      <label htmlFor="organization">Company Name</label>
                    </div>

                    <div className="form-group">
                      <TextInput
                        name="email"
                        id="email"
                        type="email"
                        placeholder="Email Address"
                        value={this.state.userDetails.email}
                        onChange={this.handleUserInfoChanged}
                        errorMessage={{ validator: "Please enter a valid email" }}
                        validator={validator.isEmail}
                        autoComplete="email"
                        required
                      />
                      <label htmlFor="email">Email Address</label>
                    </div>

                    <div className="form-row">
                      <div className="col-12 col-lg-8">
                        <div className="form-group">
                          <TextInput
                            name="phone"
                            id="phone"
                            type="tel"
                            pattern="[0-9]{10,11}"
                            placeholder="Phone Number"
                            value={this.state.userDetails.phone}
                            onChange={this.handleUserInfoChanged}
                            errorMessage={{validator:"Please enter a valid phone number", pattern:"Please enter a valid phone number"}}
                            autoComplete="tel"
                            required
                          />
                          <label htmlFor="phone">Phone Number</label>
                        </div>
                      </div>
                      <div className="col-12 col-lg-4">
                        <div className="form-group">
                          <TextInput
                            name="ext"
                            id="ext"
                            type="ext"
                            placeholder="Extension"
                            value={this.state.userDetails.ext}
                            onChange={this.handleUserInfoChanged}
                            autoComplete="tel-extension"
                          />
                          <label htmlFor="ext">Extension</label>
                        </div>
                      </div>
                    </div>
                  </ValidationForm>

                  <hr />
                  <h3 className="mt-4" ref={this.selectYourProductHeader}>Select Your Products</h3>
                  <p className="muted">
                    Offering a comprehensive suite of customer engagement solutions, all of Spectrio's products help to effectively connect your brand's messaging to the customer.
                  </p>

                  {this.state.showSelectProductErrorMessage &&
                  <p className="product-warning" style={{color: "red"}}>
                    <i className="fas fa-exclamation-triangle"></i>
                    <span>Please select a product.</span>
                  </p>
                  }

                  <div className="kiosk-demo" style={{marginBottom: "0px"}}>
                    <div className="blog-slider">

                      {Constants.PRODUCT_INFO_LIST.map((product) => (

                        <div key={product.productType} className="blog-slider__slide slide-fade active" onClick={this.handleProductCheckboxClicked(product.productType)}>
                          <span className="block">
                            <div className="img" style={{backgroundImage: "url(" + product.imgUrl + ")", }}>
                            </div>
                            <div className="content-container">
                              <div className="content">
                                <div>
                                  <span className="date">{product.header}</span>
                                  <span className="line-clamp-3">
                                    <b>{product.name}</b>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <input className="styled-checkbox" id={product.productType} type="checkbox" value="value1"
                                   checked={this.state.selectedProducts.includes(product.productType)} onChange={this.handleProductCheckboxClicked(product.productType)}/>
                            <label htmlFor={product.productType}><span>{product.header}</span></label>
                          </span>
                        </div>

                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-4 d-none d-xl-block">
                  <div className="sticky-lg pad-left-lg">
                    <div className="card card--no-hover sidebar-newsletter checkout-card marketing-card">
                      <div className="mid">
                        <b>Increase Your Customer Engagement Today!</b>
                        <div className="product-logo-row">
                          <img src={iconEngage} alt="Spectrio Engage Logo" />
                          <img src={iconInteract} alt="Spectrio Interact Logo" />
                          <img src={iconInform} alt="Spectrio Inform Logo" />
                          <img src={iconInspire} alt="Spectrio Inspire Logo" />
                          <img src={iconConnect} alt="Spectrio Connect Logo" />
                          <img src={iconEnhance} alt="Spectrio Enhance Logo" />
                        </div>
                        <ul>
                          <li>
                            <i className="fa fa-check"></i>
                            Easy cloud-based software
                          </li>
                          <li>
                            <i className="fa fa-check"></i>
                            Customizable brand content
                          </li>
                          <li>
                            <i className="fa fa-check"></i>
                            Dedicated customer service
                          </li>
                          <li>
                            <i className="fa fa-check"></i>
                            Comprehensive suite of solutions
                          </li>
                          <li>
                            <i className="fa fa-check"></i>
                            White-glove installation
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 action-row">
                  <div className="form-group mt-4">
                    <button
                      className="btn btn-primary btn-lg w-110"
                      data-testid="app-next-button"
                      onClick={this.handleNextClicked}
                    >
                      <span className={`${this.state.processingSubmit ? "d-none" : ""}`}>
                        Next
                      </span>
                      <span className={`${this.state.processingSubmit ? "" : "d-none"}`}>
                        <i className="fas fa-spinner fa-spin"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
   }
}
